import { useMemo } from 'react';
import type { IntlShape } from 'react-intl';

import { TranslationKeys } from 'app/translations';
import type { EmployeeType } from 'app/types';

type SelectItem = {
  element: string;
  value: string;
  default: boolean;
};

export const useEmployeeTypeSelectItems = (
  employeeTypes: EmployeeType[] | undefined,
  currentValue: string,
  intl: IntlShape,
): SelectItem[] =>
  useMemo(() => {
    const employeeTypesArray = (employeeTypes || []).map(type => ({
      element: type.name,
      value: type.employeeTypeId,
      default: currentValue === type.employeeTypeId,
    }));

    return [
      {
        element: intl.formatMessage({ id: TranslationKeys.employees_filter_types_none }),
        value: '',
        default: currentValue === '',
      },
      ...employeeTypesArray,
    ];
  }, [employeeTypes, currentValue, intl]);
